import React from 'react'

function IconWord({ className = '' }) {
    return (
        <svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M44.8156 11.1844C43.7312 9.70625 42.2188 7.975 40.5594 6.31562C38.9 4.65625 37.1687 3.14375 35.6906 2.05938C33.1719 0.2125 31.95 0 31.25 0H7.03125C4.87812 0 3.125 1.75312 3.125 3.90625V46.0938C3.125 48.2469 4.87812 50 7.03125 50H42.9688C45.1219 50 46.875 48.2469 46.875 46.0938V15.625C46.875 14.925 46.6625 13.7031 44.8156 11.1844ZM38.3469 8.52813C39.8469 10.0281 41.0219 11.3781 41.8906 12.5H34.3719V4.98438C35.4937 5.85313 36.85 7.02813 38.3469 8.52813ZM43.75 46.0938C43.75 46.5187 43.3937 46.875 42.9688 46.875H7.03125C6.82481 46.8726 6.6275 46.7895 6.48151 46.6435C6.33553 46.4975 6.25243 46.3002 6.25 46.0938V3.90625C6.25 3.48438 6.60938 3.125 7.03125 3.125H31.25V14.0625C31.25 14.4769 31.4146 14.8743 31.7076 15.1674C32.0007 15.4604 32.3981 15.625 32.8125 15.625H43.75V46.0938Z'
                fill='#FF0100'
            />
            <path
                d='M15.2642 20.292H17.3982L20.4782 33.36H20.5222L24.0422 20.292H26.3082L29.7842 33.36H29.8282L33.0182 20.292H35.1082L30.9062 36H28.7282L25.1422 22.8H25.0982L21.4682 36H19.2902L15.2642 20.292Z'
                fill='#FF0100'
            />
        </svg>
    )
}

export default IconWord
